import { GAME_STATUSES, EGGS_TYPES } from './constants';
import { ee } from '../eventEmitter';

const BRANCHINDEX_TAILCLASS = {
    0: 'top-left',
    1: 'top-right',
    2: 'bottom-left',
    3: 'bottom-right'
};

class View {
    #baseGameContainer = document.querySelector('.game__container');
    get baseGameContainer() {
        return this.#baseGameContainer;
    }

    #character;
    #characterTail;
    #fallenEggsContainer;
    beforePlayWindow;
    #beforePlayCountdown;
    pauseButton;

    // * dom элементы
    // меню
    scoreElement = document.querySelector('.score__value');
    livesElement = document.querySelector('.lives');

    /* матрица дом элементов ветки-слоты, аналогично матрице в model
        [
            [domElemtn.slot, domElement.slot, ... n слотов],
            ...
            n веток
        ]
    */
    #branchesElements = [];
    #branches = [];

    constructor(model) {
        this.model = model;
        this.initListeners();
        this.init();
    }

    initListeners() {
        ee.on(GAME_STATUSES.END, this.setFinalResults.bind(this));

        ee.on(GAME_STATUSES.BEFORE_PLAY, () => {
            // ! not work
            // this.update = this.playUpdate;
            // ! work
            this.drawBeforePlay();
            this.update = this.beforePlayUpdate;
        });

        ee.on(GAME_STATUSES.PLAY, () => {
            this.hideBeforePlay();
            this.update = this.playUpdate;
        });

        ee.on(GAME_STATUSES.PAUSE, () => {
            this.hideBeforePlay();
        });

        ee.on('changeOrientation', () => {
            this.hideBeforePlay();
        });
    }

    // первичная отрисовка всех элементов
    init() {
        this.initHeader();
        this.initBranches();
        this.initCharacter();
        this.initFallenEggsContainer();
        this.initBeforePlay();
        this.setResults();
        this.setSizes();
        // this.calcLightsPosition();
    }

    restartGame() {
        this.setResults();
        this.refreshSlots();
        this.refreshCharacter();
    }

    initHeader() {
        this.pauseButton = document.getElementById('pauseGame');
    }

    /* первичная отрисовка веток и слотов
       расположение веток:
        0   1
        2   3
        ...
    */
    initBranches() {
        const branchesRightContainerElement = document.createElement('div');
        const branchesLeftContainerElement = document.createElement('div');

        branchesRightContainerElement.classList.add('game__branches');
        branchesRightContainerElement.classList.add('game__branches_right');
        branchesLeftContainerElement.classList.add('game__branches');
        branchesLeftContainerElement.classList.add('game__branches_left');

        this.#baseGameContainer.appendChild(branchesRightContainerElement);
        this.#baseGameContainer.appendChild(branchesLeftContainerElement);

        const branches = [];

        // создаем ветки
        for (let branchIndex = 0; branchIndex < this.model.branchesCount; branchIndex += 1) {
            const newBranch = document.createElement('div');

            newBranch.classList.add('game__branch');
            newBranch.setAttribute('branch-index', branchIndex);

            if (branchIndex % 2) {
                branchesRightContainerElement.appendChild(newBranch);
            } else {
                branchesLeftContainerElement.appendChild(newBranch);
            }

            this.#branchesElements.push([]);

            // заполяем ветки слотами
            for (let slotIndex = 0; slotIndex < this.model.slotsCount; slotIndex += 1) {
                const newSlot = document.createElement('div');

                newSlot.classList.add('game__slot');
                newSlot.classList.add(`game__slot--${slotIndex}`);
                if (slotIndex === this.model.slotsCount - 1) newSlot.classList.add('game__slot--last');

                newBranch.appendChild(newSlot);

                this.#branchesElements[branchIndex].push(newSlot);
            }

            branches.push(newBranch);
        }

        this.#branches = branches;
    }

    initCharacter() {
        const baseClass = 'character';

        this.#character = document.createElement('div');
        this.#characterTail = document.createElement('div');
        const characterBody = document.createElement('div');

        characterBody.classList.add(`${baseClass}__body`);

        this.refreshCharacter(baseClass);

        this.#character.appendChild(this.#characterTail);
        this.#character.classList.add(baseClass);
        this.#character.appendChild(characterBody);

        this.#baseGameContainer.appendChild(this.#character);
    }

    initFallenEggsContainer() {
        this.#fallenEggsContainer = document.createElement('div');

        this.#fallenEggsContainer.classList.add('game__fallen-eggs');

        this.#baseGameContainer.appendChild(this.#fallenEggsContainer);
    }

    initControlButtons() {
        this.a = 7;
        const branches = document.querySelectorAll('.game__branch');

        Array.from(branches).forEach((branch) => {
            const button = document.createElement('button');

            button.setAttribute('type', 'button');

            button.setAttribute('branch-index', branch.getAttribute('branch-index'));
            button.classList.add('control-button');

            branch.appendChild(button);
        });
    }

    initBeforePlay() {
        this.beforePlayWindow = document.createElement('div');

        this.#beforePlayCountdown = document.createElement('p');

        this.beforePlayWindow.classList.add('game__before-play');
        this.#beforePlayCountdown.classList.add('game__before-play-countdown');

        this.beforePlayWindow.appendChild(this.#beforePlayCountdown);
        document.querySelector('.game').appendChild(this.beforePlayWindow);
    }

    setSizes() {
        const COEF_WH = 2.6;
        const MAX_WIDTH = 1920;
        // percent
        const gameHeaderHeight = 35;
        const gameWrapper = document.querySelector('.game__wrapper');
        const gameContainer = this.baseGameContainer || document.querySelector('.game__container');

        const headerHeight = (gameWrapper.clientHeight * gameHeaderHeight) / 100;

        let containerWidth = gameWrapper.clientWidth;
        let containerHeight = (containerWidth / COEF_WH);

        // max width
        if (gameWrapper.clientWidth >= MAX_WIDTH) {
            containerWidth = MAX_WIDTH;
            containerHeight = containerWidth / COEF_WH;
        } else if (containerHeight >= gameWrapper.clientHeight - headerHeight) {
            // max height
            containerHeight = gameWrapper.clientHeight - headerHeight;
            containerWidth = containerHeight * COEF_WH;
        }

        let cssParams = `--branch-width: ${containerWidth * 0.26}px; --game-width: ${containerWidth}px; `;

        gameContainer.style.width = `${containerWidth}px`;
        gameContainer.style.height = `${containerHeight}px`;

        // console.log(window.innerHeight);

        cssParams += `--start-page-height: ${window.innerHeight}px`;
        document.documentElement.style.cssText = '';
        document.documentElement.style.cssText += cssParams;

        if (containerWidth === 0 || containerHeight === 0) {
            this.setSizes();
        }
    }

    refreshSlots() {
        this.#branchesElements.forEach((branch) => {
            Array.from(branch).forEach((slot) => {
                Object.values(EGGS_TYPES).forEach((type) => {
                    slot.classList.remove(type);
                });
            });
        });
    }

    refreshCharacter(baseClass = 'character') {
        const tailClass = 'tail';

        this.#characterTail.classList = '';
        this.#characterTail.classList.add(`${baseClass}__${tailClass}`);
        this.drawCharacterPosition();
    }

    // устанаваливаем значение жизней и баллов
    setResults() {
        this.scoreElement.innerHTML = this.model.score;
        Array.from(this.livesElement.children).forEach((el) => {
            if (el.getAttribute('liveindex') > this.model.livesCount) {
                el.classList.remove('lives__live_full');
            } else {
                el.classList.add('lives__live_full');
            }
        });
    }

    setFinalResults() {
        const resultsValue = document.getElementById('resultsValue');

        resultsValue.innerHTML = this.model.score;
    }

    // eslint-disable-next-line
    update = function () {};

    beforePlayUpdate() {
        if (this.model.countdownUpdated) {
            this.#beforePlayCountdown.innerHTML = this.model.countdown;
        }
    }

    playUpdate() {
        if (this.model.branchesIndexChanges.length) {

            this.drawEggs();

            if (this.model.accentEvent) this.triggerLights();

            if (this.model.fallenEgg) {
                this.drawfallenEggs();
                this.setResults();
            }

            if (this.model.takenEgg) {
                this.drawTakenEggs();
                this.setResults();
            }
        }
    }

    // показать экран с обратным отсчетом
    drawBeforePlay() {
        this.beforePlayWindow.classList.add('game__before-play_active');
    }

    hideBeforePlay() {
        this.beforePlayWindow.classList.remove('game__before-play_active');
    }

    // отрисовка шаров в слотах
    drawEggs() {
        this.model.branchesIndexChanges.forEach((branchChangeIndex) => {
            this.#branchesElements[branchChangeIndex].forEach((slot, slotIndex) => {
                const prevAttribute = slot.getAttribute('data-egg-type');

                if (prevAttribute !== this.model.defaultEggType) {
                    slot.classList.remove(`${prevAttribute}`);
                }

                const newAttribute = this.model.branchesCondition[branchChangeIndex][slotIndex];

                slot.setAttribute('data-egg-type', newAttribute);
                slot.classList.add(newAttribute);
            });
        });
    }

    // отрисовка разбитых яиц
    drawfallenEggs() {
        const { fallenEgg } = this.model;

        if (!fallenEgg) return;

        const newFallenEggElement = document.createElement('div');

        newFallenEggElement.classList.add('game__fallen-egg');
        newFallenEggElement.classList.add(fallenEgg.eggType);
        newFallenEggElement.classList.add(`game__fallen-egg_${BRANCHINDEX_TAILCLASS[fallenEgg.branchIndex]}`);

        this.#fallenEggsContainer.appendChild(newFallenEggElement);
        setTimeout(() => {
            newFallenEggElement.classList.add('game__fallen-egg_remove');
            newFallenEggElement.classList.add(`game__fallen-egg_remove_${BRANCHINDEX_TAILCLASS[fallenEgg.branchIndex]}`);
        }, 0);

        // setTimeout(() => {
        //     this.#fallenEggsContainer.removeChild(newFallenEggElement);
        // }, 100);
    }

    drawTakenEggs() {
        const { takenEgg } = this.model;

        if (!takenEgg) return;

        this.#character = document.querySelector('.character');
        const newTakenEggElement = document.createElement('div');
        const svg = `<svg width="60" height="60" viewBox="-30 -30 60 60">
            <line x1="14.5" y1="0" x2="29.5" y2="0" stroke="#fff" stroke-width="1" stroke-linecap="round" />
            <line transform="rotate(60)" x1="14.5" y1="0" x2="29.5" y2="0" stroke="#fff" stroke-width="1" stroke-linecap="round" />
            <line transform="rotate(120)" x1="14.5" y1="0" x2="29.5" y2="0" stroke="#fff" stroke-width="1" stroke-linecap="round" />
            <line transform="rotate(180)" x1="14.5" y1="0" x2="29.5" y2="0" stroke="#fff" stroke-width="1" stroke-linecap="round" />
            <line transform="rotate(240)" x1="14.5" y1="0" x2="29.5" y2="0" stroke="#fff" stroke-width="1" stroke-linecap="round" />
            <line transform="rotate(300)" x1="14.5" y1="0" x2="29.5" y2="0" stroke="#fff" stroke-width="1" stroke-linecap="round" />
        </svg>`;

        newTakenEggElement.classList.add('character__snowball');
        newTakenEggElement.classList.add(`character__snowball__${BRANCHINDEX_TAILCLASS[takenEgg.branchIndex]}`);
        newTakenEggElement.innerHTML = svg;

        this.#character.insertBefore(newTakenEggElement, this.#character.firstElementChild.nextSibling);

        setTimeout(() => {
            newTakenEggElement.classList.add('character__snowball_remove');
        }, 100);

        setTimeout(() => {
            this.#character.removeChild(newTakenEggElement);
        }, 600);
    }

    // отрисовка положения персонажа по индексу ветки в model
    drawCharacterPosition() {
        const baseClass = 'character__tail';
        const branchClass = 'game__branch';

        const nextAttr = this.model.characterPosition;
        let prevAttr = this.#characterTail.getAttribute('branch-index');
        let prevPrevAttr = this.#characterTail.getAttribute('branch-prev-index');

        if (+prevAttr === +nextAttr) return;

        // Стартовый Fallback для индекса, из какого sprite sheet взять конечное изображение или показать переход
        const getPrevIndexDefault = (nextIndex) => (nextIndex.toString() === '0' ? '1' : '0');

        if (prevAttr) {
            const prevIndex = Number.parseInt(prevAttr, 10);

            prevPrevAttr = prevPrevAttr || getPrevIndexDefault(prevAttr);

            this.#characterTail.classList.remove(
                `${baseClass}_${BRANCHINDEX_TAILCLASS[prevAttr]}`
            );
            this.#characterTail.classList.remove(
                `${baseClass}_${BRANCHINDEX_TAILCLASS[prevAttr]}__from-${BRANCHINDEX_TAILCLASS[prevPrevAttr]}`
            );

            if (prevIndex > -1 && prevIndex < this.#branches.length) {
                const brnch = this.#branches[prevIndex];

                brnch.classList.remove(`${branchClass}_current`);
            }
        }

        prevAttr = prevAttr || getPrevIndexDefault(nextAttr);

        this.#characterTail.setAttribute('branch-prev-index', prevAttr);
        this.#characterTail.setAttribute('branch-index', nextAttr);
        this.#characterTail.classList.add(
            `${baseClass}_${BRANCHINDEX_TAILCLASS[nextAttr]}`
        );
        this.#characterTail.classList.add(
            `${baseClass}_${BRANCHINDEX_TAILCLASS[nextAttr]}__from-${BRANCHINDEX_TAILCLASS[prevAttr]}`
        );

        const nextIndex = Number.parseInt(nextAttr, 10);

        if (nextIndex > -1 && nextIndex < this.#branches.length) {
            const brnch = this.#branches[nextIndex];

            brnch.classList.add(`${branchClass}_current`);
        }
    }

    // анимация огоньков
    // eslint-disable-next-line
    triggerLights() {
        const lightsSide = document.getElementsByClassName('bg-border-outside__lights');
        const lghtsInside = document.getElementsByClassName('bg-border-inside__lights');
        const timeout = 65;
        const accentTimeout = 130;

        Array.from(lghtsInside).forEach((lightsContainer) => {
            const lights = lightsContainer.children;

            Array.from(lights).forEach((light, index) => {
                light.classList.toggle('bg-border-inside__light_active');
                setTimeout(() => {
                    light.classList.toggle('bg-border-inside__light_active');
                }, (timeout * (Array.from(lights).length - index)) + (accentTimeout));
            });
        });

        Array.from(lightsSide).forEach((lightsContainer) => {
            const lights = lightsContainer.children;

            Array.from(lights).forEach((light) => {
                light.classList.toggle('bg-border-outside__light_active');

                // this.triggerLight();

                setTimeout(() => {
                    light.classList.toggle('bg-border-outside__light_active');
                }, (timeout * light.getAttribute('light-index')) + (accentTimeout) + (timeout * 5));
            });
        });
    }

    // triggerLight() {
    //     this.a = 9;
    //     // light.classList.toggle(`${baseClass}_active`);
    //     console.log('trigger light');
    //     requestAnimationFrame(this.triggerLight);
    // }
}

export default View;
